import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createpress, updatepress, getpress, deletepresss } from '../../ReduxToolkit/Slice/Gallery/Press';
import { Link } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';



function Press() {
  const dispatch = useDispatch();
  const { status, presss } = useSelector((state) => state.press);
  const [PressImage, setPressImage] = useState(null);
  const [title, setTitle] = useState("");

  // create
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('PressImage', PressImage === null ? "" : PressImage);
    formData.append('title', title);
    dispatch(createpress(formData));
    setPressImage(null);
    setTitle("");
  };
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getpress())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (pressid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this PressRealse Image?")
    if (Isconfirmed) {
      dispatch(deletepresss(pressid))
    };
    
  }
  // single data fetch
  const [updateButton, setupdateButton] = useState("d-none")
  const [SubmitButton, setSubmitButton] = useState("")
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selectepress = presss.data.find(press => press._id === id);
    setTitle(selectepress.title);
    setPressImage(selectepress.press);
    setSelectedId(id);
    if (selectepress) {
      setupdateButton("")
      setSubmitButton("d-none")
    }
    else { }
  };
  // update
  const handleEdit = () => {
    const formData = new FormData();
    formData.append('PressImage', PressImage === null ? "" : PressImage);
    formData.append('title', title);
    dispatch(updatepress({ selectedId, formData }));
    setPressImage(null);
    setTitle("");
  }
  const columns = [
    { label: "Title", accessor: "title" },
  ];
  return (
    <>
      <div>
        <ToastContainer/>
        <div className='d-flex justify-content-between my-3'>
          <h3>Press Realse</h3>
          <Link to="/gallery"> <button className='btn btn-sm bg-primary text-white'>Images</button></Link>
          <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i>  Press Realse </button>
        </div>
      
        <CommanTable
                    columns={columns}
                    data={presss.data || []}
                    status={status}
                    onDelete={handleDelete}
                    onEdit={handlid}
                    databstarget="#exampleModal"
                    model="modal"
                />
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload press
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row">

                <div className="mb-3 col-lg-6">
                  <label htmlFor="title" className="form-label">
                    Image Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title"
                  />
                </div>
                <div className="mb-3 col-lg-6">
                  {/* <img src={thumbnail} className='img-fluid rounded' alt="" /> */}
                  <label htmlFor="press" className="form-label">
                    Gellery Image
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="thumbnail"
                    name="thumbnail"
                    // value={thumbnail}
                    onChange={(e) => setPressImage(e.target.files[0])}
                  />
                </div>

              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" onClick={handleEdit} className={`${updateButton} btn btn-primary`} data-bs-dismiss="modal"  >
                  Update
                </button>
                <button type="submit" onClick={handleSubmit} className={`${SubmitButton} btn btn-primary`} data-bs-dismiss="modal"  >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Press;
